import { faWandMagicSparkles } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

export default function CreateNewProductCard({ products }: Readonly<{ products?: boolean }>) {
  const { t } = useTranslation('productLibrary');

  return (
    <CreateProductCardContent to="/create-product" products={products} data-testid="create-product-card">
      <FontAwesomeIcon icon={faWandMagicSparkles} size="5x" />
      <CreateProductCardHeader>{t('createProduct')}</CreateProductCardHeader>
      <CreateProductCardSubHeader>({t('adminOnly')})</CreateProductCardSubHeader>
    </CreateProductCardContent>
  );
}

const shouldForwardProp = (prop: string) => prop !== 'products';
const CreateProductCardContent = styled(NavLink, { shouldForwardProp })<{ products?: boolean }>`
  /* istanbul ignore next */
  ${({ products }) => /* istanbul ignore next */ !products && 'aspect-ratio: 1.3;'};
  background-color: ${({ theme }) => theme.palette.common.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 3px ${({ theme }) => theme.palette.grey[400]} dashed;
  transition: border-color 0.25s;
  &:hover {
    border-color: ${({ theme }) => theme.palette.secondary.main};
  }
  &:hover > h3,
  &:hover > h4 {
    border-bottom-color: black;
  }
`;

const CreateProductCardHeader = styled('h3')`
  font-weight: bold;
  text-align: center;
  font-size: 2.125rem;
  margin-top: 1.5rem;
  margin-bottom: 0;
  line-height: 2rem;
  transition: border-color 0.3s;
  border-bottom: 2px solid transparent;
`;

const CreateProductCardSubHeader = styled('h4')`
  font-size: 1.25rem;
  font-weight: normal;
  margin-top: 0.5rem;
  margin-bottom: 0;
  transition: border-color 0.3s;
  border-bottom: 1px solid transparent;
`;
